import "./ApplicationDevelopment.module.css";
import Header from "@/reusable_sections/Header";
import MethodEngineeringHero from "./sections/MethodEngineeringHero";
import ProcessGrid from "./sections/ProcessGrid";
import PatGrid from "./sections/PatGrid";
import ChemometricServices from "./sections/ChemometricServices";
import Inquiry from "./sections/Inquiry";
import Footer from "@/reusable_sections/Footer";
export default function ApplicationDevelopmentPage() {
  return <div>
      <Header />
      <MethodEngineeringHero />
      <ProcessGrid />
      <PatGrid />
      <ChemometricServices />
      <Inquiry />
      <Footer />
    </div>;
}